<script>
import { nextTick } from "vue";
import { swal } from "../../helpers/handle_error.js";
import { required, minLength, maxLength, url } from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../helpers/validators_files.js";
import { main_section, sub_section } from "../../helpers/lists.js";
import appConfig from "@/app.config";

export default {
  components: {},
  props: {},
  data() {
    return {
      fields: [],

      //lists
      list_main_section: main_section,
      list_sub_section: sub_section,
    };
  },
  validations: {
    fields: {
      $each: {
        main_section_id: { required },
        sub_section_id: { required },
        artwork_name: { required, minLength: minLength(2), maxLength: maxLength(100) },
        attachment_1: {
          fileType: fileType(appConfig.acceptFile.files.map((f) => f.mimeType)),
          fileSize: fileSize(appConfig.acceptFile.maxSize),
          atLeastOneRequired(value, parent) {
            return !!(value || parent.additional_link);
          },
        },
        additional_link: {
          url,
          maxLength: maxLength(500),
          atLeastOneRequired(value, parent) {
            return !!(value || parent.attachment_1);
          },
        },
        notes: { minLength: minLength(2), maxLength: maxLength(2000) },
      },
    },

    form: ["fields"],
  },
  computed: {
    filteredSubSections() {
      return this.fields.map((field) => {
        if (field.main_section_id === 1) {
          return this.list_sub_section.filter((sub) => sub.id >= 1 && sub.id <= 11);
        } else if (field.main_section_id === 2) {
          return this.list_sub_section.filter((sub) => sub.id >= 12 && sub.id <= 18);
        } else if (field.main_section_id === 3) {
          return this.list_sub_section.filter((sub) => sub.id >= 19 && sub.id <= 25);
        } else {
          return [];
        }
      });
    },
    acceptedTypes() {
      return appConfig.acceptFile.files.map((f) => f.extension).join(",");
    },
  },
  methods: {
    //  Push the row in form
    AddformDataS() {
      this.fields.push({
        main_section_id: "",
        sub_section_id: "",
        artwork_name: "",
        attachment_1: "",
        additional_link: "",
        notes: "",
      });

      nextTick(() => {
        const lastIndex = this.fields.length - 1;
        const lastBlock = this.$refs["block-" + lastIndex];
        // refs تصبح مصفوفة إذا تكررت بنفس الاسم
        const el = Array.isArray(lastBlock) ? lastBlock[0] : lastBlock;
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    // Delete the row
    async deleteRowS(index) {
      if (await swal.confirm()) {
        this.fields.splice(index, 1);
        this.list_health_status_family.splice(index, 1);
      }
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      // this.$emit("on-validate", this.$data, isValid);

      if (isValid) {
        const artworks = this.fields.map((field) => {
          const mainSection = this.list_main_section.find(
            (section) => section.id === field.main_section_id
          );
          const subSection = this.list_sub_section.find(
            (section) => section.id === field.sub_section_id
          );

          return {
            main_name: mainSection ? mainSection.name : "",
            sub_name: subSection ? subSection.name : "",
            artwork_name: field.artwork_name,
          };
        });

        this.$emit("on-validate", { artworks }, isValid);
      }

      return isValid;
    },
    changeFile(e) {
      e = e.target;
      let index = e.getAttribute("data-index");
      this.fields[index][e.id] = e.files.length > 0 ? e.files[0] : null;
    },
  },
  created() {
    this.AddformDataS();
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <div class="title-separator">
        <h4>{{ $t("components.art_work.title") }}</h4>
      </div>

      <div class="col-md-12">
        <div class="alert alert-secondary" style="border-radius: 15px">
          <h5 class="alert-heading">
            {{ $t("components.art_work.note_art_work.title") }}
          </h5>
          <div class="con-note_art_work mb-2">
            <ul>
              <li>
                <p>{{ $t("components.art_work.note_art_work.note1") }}</p>
              </li>
              <li>
                <p>{{ $t("components.art_work.note_art_work.note2") }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <form class="repeater" enctype="multipart/form-data">
        <div
          v-for="(field, index) in $v.fields.$each.$iter"
          :key="field.id"
          class="con-all-form con-repeater"
          :ref="'block-' + index"
        >
          <div class="row">
            <div class="col-md-12" v-if="fields.length > 1">
              <p>{{ $t("components.art_work.sub-title") + " " + (Number(index) + 1) }}</p>
            </div>
            <b-form-group class="col-md-6 mb-3">
              <label for="main_section_id"
                >{{ $t("components.art_work.main_section.label")
                }}<span class="required">*</span></label
              >
              <select
                class="form-control form-select"
                id="main_section_id"
                v-model.trim="field.main_section_id.$model"
                :class="{ 'is-invalid': field.main_section_id.$error }"
              >
                <option value="">
                  {{ $t("components.art_work.main_section.default-option") }}
                </option>
                <option
                  v-for="main_section in list_main_section"
                  :value="main_section.id"
                  :key="main_section.id"
                >
                  {{ main_section.name }}
                </option>
              </select>
              <div v-if="field.main_section_id.$error" class="invalid-feedback">
                <span v-if="!field.main_section_id.required">{{
                  $t("components.art_work.main_section.validation.required")
                }}</span>
              </div>
            </b-form-group>
            <b-form-group class="col-md-6 mb-3">
              <label for="sub_section_id"
                >{{ $t("components.art_work.sub_section.label")
                }}<span class="required">*</span></label
              >
              <select
                class="form-control form-select"
                id="sub_section_id"
                v-model.trim="field.sub_section_id.$model"
                :class="{ 'is-invalid': field.sub_section_id.$error }"
              >
                <option value="">
                  {{ $t("components.art_work.sub_section.default-option") }}
                </option>
                <option
                  v-for="sub_section in filteredSubSections[index]"
                  :value="sub_section.id"
                  :key="sub_section.id"
                >
                  {{ sub_section.name }}
                </option>
              </select>
              <div v-if="field.sub_section_id.$error" class="invalid-feedback">
                <span v-if="!field.sub_section_id.required">{{
                  $t("components.art_work.sub_section.validation.required")
                }}</span>
              </div>
            </b-form-group>
          </div>

          <div class="row">
            <b-form-group class="col-md-12 mb-3">
              <label for="artwork_name"
                >{{ $t("components.art_work.artwork_name.label")
                }}<span class="required">*</span></label
              >
              <b-form-input
                id="artwork_name"
                type="text"
                :placeholder="$t('components.art_work.artwork_name.placeholder')"
                v-model.trim="field.artwork_name.$model"
                :class="{ 'is-invalid': field.artwork_name.$error }"
              ></b-form-input>
              <div v-if="field.artwork_name.$error" class="invalid-feedback">
                <span v-if="!field.artwork_name.required">{{
                  $t("components.art_work.artwork_name.validation.required")
                }}</span>
                <span v-if="!field.artwork_name.minLength">{{
                  $t("components.art_work.artwork_name.validation.minLength")
                }}</span>
                <span v-if="!field.artwork_name.maxLength">{{
                  $t("components.art_work.artwork_name.validation.maxLength")
                }}</span>
              </div>
            </b-form-group>
          </div>

          <div class="con-note-attachment">
            <h5>{{ $t("components.art_work.note-attachment.title") }}</h5>
            <ul>
              <li>
                <p>{{ $t("components.art_work.note-attachment.note1") }}</p>
              </li>
              <li>
                <p>{{ $t("components.art_work.note-attachment.note2") }}</p>
              </li>
              <li>
                <p>{{ $t("components.art_work.note-attachment.note3") }}</p>
              </li>
              <li>
                <p>{{ $t("components.art_work.note-attachment.note4") }}</p>
              </li>
              <li>
                <p>{{ $t("components.art_work.note-attachment.note5") }}</p>
              </li>
            </ul>
            <div class="row">
              <b-form-group
                class="col-md-12 mb-3"
                :label="$t('components.art_work.attachment_1.label')"
                :label-for="'attachment_1' + index"
              >
                <div class="custom_file">
                  <b-form-file
                    :id="'attachment_1' + index"
                    class=""
                    :data-index="index"
                    :placeholder="$t('components.art_work.attachment_1.placeholder')"
                    :accept="acceptedTypes"
                    v-model.trim="field.attachment_1.$model"
                    :class="{ 'is-invalid': field.attachment_1.$error }"
                    @change="changeFile"
                  ></b-form-file>
                  <div v-if="field.attachment_1.$error" class="invalid-feedback">
                    <span v-if="!field.attachment_1.fileSize">{{
                      $t("components.art_work.attachment_1.validation.fileSize")
                    }}</span>
                    <span v-if="!field.attachment_1.fileType">{{
                      $t("components.art_work.attachment_1.validation.fileType")
                    }}</span>
                    <span v-if="!field.attachment_1.atLeastOneRequired">
                      {{
                        $t(
                          "components.art_work.attachment_1.validation.atLeastOneRequired"
                        )
                      }}
                    </span>
                  </div>
                </div>
              </b-form-group>
              <b-form-group
                class="col-md-12 mb-3"
                :label="$t('components.art_work.additional_link.label')"
                label-for="additional_link"
              >
                <b-form-input
                  id="additional_link"
                  type="url"
                  :placeholder="$t('components.art_work.additional_link.placeholder')"
                  v-model.trim="field.additional_link.$model"
                  :class="{ 'is-invalid': field.additional_link.$error }"
                ></b-form-input>
                <div v-if="field.additional_link.$error" class="invalid-feedback">
                  <span v-if="!field.additional_link.url">{{
                    $t("components.art_work.additional_link.validation.url")
                  }}</span>
                  <span v-if="!field.additional_link.maxLength">{{
                    $t("components.art_work.additional_link.validation.maxLength")
                  }}</span>
                  <span v-if="!field.additional_link.atLeastOneRequired">
                    {{
                      $t(
                        "components.art_work.additional_link.validation.atLeastOneRequired"
                      )
                    }}
                  </span>
                </div>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <b-form-group
              class="col-md-12 mb-3"
              :label="$t('components.art_work.notes.label')"
              label-for="notes"
            >
              <b-form-Textarea
                id="notes"
                type="text"
                rows="4"
                :placeholder="$t('components.art_work.notes.placeholder')"
                v-model.trim="field.notes.$model"
                :class="{ 'is-invalid': field.notes.$error }"
              ></b-form-Textarea>
              <div v-if="field.notes.$error" class="invalid-feedback">
                <span v-if="!field.notes.minLength">{{
                  $t("components.art_work.notes.validation.minLength")
                }}</span>
                <span v-if="!field.notes.maxLength">{{
                  $t("components.art_work.notes.validation.maxLength")
                }}</span>
              </div>
            </b-form-group>
          </div>

          <div class="row">
            <b-form-group
              class="col-md-12"
              label=""
              label-for=""
              v-if="fields.length > 1"
            >
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-danger btn-delete"
                  @click="deleteRowS(index)"
                >
                  <i class="bx bx-trash font-size-16 align-middle"></i>
                  {{ $t("components.art_work.delete_button") }}
                  {{ Number(index) + 1 }}
                </button>
              </div>
            </b-form-group>
          </div>
        </div>
        <button type="button" class="btn btn-primary btn-add" @click="AddformDataS">
          <i class="bx bx-plus font-size-16 align-middle"></i>
          {{ $t("components.art_work.add_button") }}
        </button>
      </form>
    </div>
  </div>
  <!-- end page title -->
</template>
